import React, { useState, useEffect } from "react";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helperNumber from "../../../../../helpers/numbers";
import helperTime from "../../../../../helpers/time";
import StatusPledge from "../../StatusPledge";
import Pagination from "../../../../partials/content/Pagination";

export default function AllPledgeCustomer({ userID }) {
  const [pledges, setPledges] = useState([]);
  const [tokenCustomer, setTokenCustomer] = useState();

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getTokenCustomer();
  }, [tokenCustomer]);

  useEffect(() => {
    setTokenCustomer();
  }, [userID]);

  useEffect(() => {
    if (!tokenCustomer) {
      return;
    }

    getAllPledgeCustomer();
  }, [currentPage, countItemPerPage, tokenCustomer]);

  const getTokenCustomer = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetTokenUser = await sendRequestGetTokenUser(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetTokenUser) {
      return;
    }

    setTokenCustomer(resultSendRequestGetTokenUser);
  };

  const getHeaderRequestForCustomer = () => {
    const headersRequest = {
      headers: {
        authorization: `Bearer ${tokenCustomer}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetTokenUser = async (userID) => {
    let token;
    let headersRequest = getHeaderRequest();
    try {
      token = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/enter-users-profile-customer-coworker/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return token.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const sendRequestGetAllPledgeCustomer = async () => {
    const headersRequest = getHeaderRequestForCustomer();
    let pledges;
    try {
      pledges = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/pledge?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return pledges.data.data;
  };

  const getAllPledgeCustomer = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allPledgeCustomer = await sendRequestGetAllPledgeCustomer();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allPledgeCustomer) {
      return;
    }

    setPledges(allPledgeCustomer.pledges);
    setCountPage(allPledgeCustomer.count_page);
  };

  const generatePledgeCustomerTag = () => {
    return (
      <>
        <div className="pt-3">
          <div className="alert alert-warning">
            <p className="text-justify">
              <i className="fa fa-info pl-2"></i>
              توجه داشته باشید :{" "}
            </p>
            <ul className="pr-3">
              <li>
                <p className="text-justify">
                  بیعانه مبلغی است که جهت رزور جایگاه های انتخابی کمپین شما از
                  موجودی حساب شما کسر میشود.
                </p>
              </li>
              <li>
                <p className="text-justify">
                  %۳۳ مبلغ کمپین بابت رزور جایگاه های انتخابی شما به عنوان
                  بیعانه در زمان درج کمپین از موجودی حساب شما کسر میگردد.
                </p>
              </li>
              <li>
                <p className="text-justify">
                  مبلغ بیعانه در صورت اتمام زمان کمپین به حساب شما بازگردانده
                  خواهد شد.
                </p>
              </li>
              <li>
                <p className="text-justify">
                  در صورت کنسل شدن کمپین مبلغ بیعانه به موجودی حساب شما بازگشت
                  داده نخواهد شد.
                </p>
              </li>
            </ul>
          </div>

          <div className="table-responsive">
            <table className="table table-hilite tbl-td-white-space  m-0">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره</td>
                  <td>مبلغ (تومان)</td>
                  <td>نام کمپین</td>
                  <td>وضعیت</td>
                  <td>تاریخ اخذ</td>
                  <td>تاریخ بازگشت</td>
                </tr>
              </thead>
              <tbody>
                {pledges.map((item, key) => {
                  return (
                    <tr key={item.id}>
                      <td>{helperNumber.toPersianNum(key + 1)}</td>
                      <td>{helperNumber.toPersianNum(item.id)}</td>
                      <td className="number-finance">
                        {helperNumber.toPersianNum(
                          helperNumber.toFormatFinanceNumber(item.amount)
                        )}
                      </td>
                      <td>{item.campaign}</td>
                      <td>
                        <span
                          className={`badge 
               ${
                 item.status === StatusPledge.statusPledge.BLOCK
                   ? "badge-danger"
                   : ""
               } 
               ${
                 item.status === StatusPledge.statusPledge.GET
                   ? "badge-warning"
                   : ""
               } 
               ${
                 item.status === StatusPledge.statusPledge.GIVE
                   ? "badge-success"
                   : ""
               } 
            `}
                        >
                          {StatusPledge.statusPledgeString()[item.status]}
                        </span>
                      </td>
                      <td>
                        {helperNumber.toPersianNum(
                          helperTime.convertGregorianToJalali(item.created_at)
                        )}
                      </td>
                      <td>
                        {item.returned_at !== null
                          ? helperNumber.toPersianNum(
                              helperTime.convertGregorianToJalali(
                                item.returned_at
                              )
                            )
                          : ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generateDoNotHavePledgeCustomerTag = () => {
    return (
      <div class="d-flex flex-column flex-md-row">
        <div class="text-center text-md-right">
          <img class="img-fluid" src="/assets/img/do-not-have-pledge.svg" />
        </div>
        <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p className="text-justify">
            این کاربر تاکنون هیچ کمپین تبلیغاتی نداشته و در نتیجه بیعانه پرداختی
            ندارد
          </p>
          <p className="text-justify">
            بیعانه مبلغی است که جهت رزور جایگاه های انتخابی کمپین از موجودی
            کاربر کسر میشود.
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      {pledges.length == 0
        ? generateDoNotHavePledgeCustomerTag()
        : generatePledgeCustomerTag()}
    </>
  );
}
